import { usePetitionDetailsPageFcm } from 'src/app/pages/petition/details/pageContext';

/**
 * @deprecated use usePetitionDetailsPageFcm() instead
 */
export const useFcm = usePetitionDetailsPageFcm;
